import React from 'react';
import { SettingsContextType, GlobalErrorContextType } from './types';
export const SettingsContext = React.createContext<SettingsContextType>({
  layoutWidth: 'xs',
  setLanguage: () => {},
  setLayoutWidth: () => {}
});

export const GlobalErrorContext = React.createContext<GlobalErrorContextType>({
  setGlobalError: () => {}
});
